// extracted by mini-css-extract-plugin
module.exports = {"layout":"agenda-speaker-card_layout__fjHfa","photoContainer":"agenda-speaker-card_photoContainer__0y5qQ","photo":"agenda-speaker-card_photo__ppmGw"};